module.exports = __webpack_public_path__ + "img/hand.78b89eab.svg";